












































































import Vue, { PropType } from 'vue';
import FiltersPanel from '@/components/table/FiltersPanel.vue';
import PaginationPanel from '@/components/table/PaginationPanel.vue';
import TableHeadCell from '@/components/table/TableHeadCell.vue';
import TableBodyCell from '@/components/table/TableBodyCell.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import filterParams from '@/components/table/utils/filterParameters';
import { Column, ESortTypes } from './types';
import { PaginationData } from '@/types';
import { IDefaultSort } from '@/types/dashboard';

export default Vue.extend({
  name: 'TableLight',
  components: {
    FiltersPanel,
    PaginationPanel,
    TableHeadCell,
    TableBodyCell,
    Preloader,
  },

  props: {
    data: {
      type: Array as PropType<Array<any>>,
      required: true,
      default: () => [],
    },
    columns: {
      type: Array as PropType<Array<Column>>,
      required: true,
      default: () => [],
    },
    paginationData: {
      type: Object as PropType<PaginationData>,
      required: false,
      default: () => ({
        totalCount: null,
        pageCount: null,
        currentPage: null,
        perPage: 20,
      }),
    },
    isFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
    outFilterData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isPagination: {
      type: Boolean,
      required: false,
      default: true,
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultSort: {
      type: Object as PropType<IDefaultSort>,
      required: false,
      default: null,
    },
  },

  mounted() {
    if (!this.paginationData || !this.isFilters) return;

    this.addParamsToFilterData({
      fields: this.columnFields,
      per__page: +this.paginationData?.perPage,
      page: this.paginationData?.currentPage,
    });
  },

  beforeDestroy() {
    this.deleteFilterParamsFromUrl();
  },

  watch: {
    paginationData(newValue) {
      this.paginationForm = { ...newValue };
      this.addParamsToFilterData({
        per__page: +newValue.perPage,
        page: newValue.currentPage,
      });
    },
    outFilterData(newValue) {
      this.filterData = { ...this.filterData, ...newValue };
      this.addFilterParamsToUrl();
    },
    columns: {
      handler() {
        if (this.defaultSort) {
          const index: number = this.columns.findIndex(
            (column) => column.field === this.defaultSort.field
          );
          if (index !== -1) {
            this.sortedColumnIndex = index;
          }
          this.scrollToTop();
        }
      },
      deep: true,
    },
  },

  computed: {
    columnFields(): string {
      return this.columns
        .filter((column) => column.field)
        .map((column) => column.field)
        .join(',');
    },
    formatFilterData(): any {
      const formatFilterData = {};

      for (const item in this.filterData) {
        if (item !== 'fields') {
          formatFilterData[item] = this.filterData[item];
        }
      }

      return formatFilterData;
    },
  },

  methods: {
    bodyCellEvent(rowData, value = null) {
      this.$emit('bodyCellEvent', rowData, value);
    },
    changeColumnSort(sortValue, columnIndex) {
      this.sortedColumnIndex = columnIndex;
      if (this.isFilters) {
        this.addParamsToFilterData({ sort: sortValue });
      }

      this.$emit('changeSort', sortValue);
    },
    isSortedColumn(coluntIndex) {
      return this.sortedColumnIndex === coluntIndex;
    },
    changeCurrentPage(page) {
      this.paginationForm.currentPage = page;
      this.addParamsToFilterData({ page });
    },
    changePerPage(perPage) {
      this.paginationForm.perPage = +perPage;
      this.addParamsToFilterData({
        per__page: +perPage,
      });
    },
    addParamsToFilterData(params) {
      this.filterData = { ...this.filterData, ...params };
      this.addFilterParamsToUrl();
      this.loadNewData();
    },
    deleteFilterParamsFromUrl() {
      for (const param in this.filterData) {
        filterParams.deleteParamFromUrl(param);
      }

      filterParams.deleteParamFromUrl('filter');
    },
    addFilterParamsToUrl() {
      for (const param in this.formatFilterData) {
        if (this.formatFilterData[param] === null) {
          filterParams.deleteParamFromUrl(param);
          continue;
        }

        filterParams.changeUrlParams(param, this.formatFilterData[param]);
      }
    },
    optionsColumn(column: Column) {
      if (column.options) {
        return column.options;
      }
      return {};
    },
    loadNewData() {
      this.$emit('loadNewData', this.filterData);
    },
    scrollToTop() {
      (this.$refs.tableLightContainer as any).scrollTop = 0;
    },
    checkDefaultSort(field) {
      if (this.defaultSort && this.defaultSort.field === field) {
        return this.defaultSort.sort;
      }

      return ESortTypes.NONE;
    },
  },

  data() {
    return {
      sortedColumnIndex: null as number | null,
      paginationForm: this.paginationData,
      filterData: {},
    };
  },
});
